export default function isAuthenticated(to, from, next) {
	if (!localStorage.getItem("token")) {
		return next({ name: "Login" })
	} else { (to.name == "Root") ? next({ name: "Orders" }) : next() }
}
